import React from 'react';

const SummaryCards = ({ summary }) => {
  const cards = [
    {
      title: 'Total Visits',
      value: summary.totalVisits,
      icon: '📋',
      color: 'bg-blue-50',
      textColor: 'text-blue-600'
    },
    {
      title: 'Total Sales',
      value: `₹${(summary.totalSales || 0).toLocaleString()}`,
      icon: '💰',
      color: 'bg-green-50',
      textColor: 'text-green-600'
    },
    {
      title: 'Monthly Revenue',
      value: `₹${(summary.monthlySales || 0).toLocaleString()}`,
      icon: '📈',
      color: 'bg-purple-50',
      textColor: 'text-purple-600'
    },
    {
      title: 'Work Plans',
      value: summary.totalWorkPlans,
      icon: '📅',
      color: 'bg-orange-50',
      textColor: 'text-orange-600'
    },
    {
      title: "Today's Visits",
      value: summary.todayVisits,
      icon: '📍',
      color: 'bg-indigo-50',
      textColor: 'text-indigo-600'
    },
    {
      title: 'Upcoming Plans',
      value: summary.upcomingPlans,
      icon: '⏳',
      color: 'bg-rose-50',
      textColor: 'text-rose-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`${card.color} rounded-lg p-6 border border-gray-200 transition-all hover:shadow-md`}
        >
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{card.title}</p>
              <p className={`text-2xl font-bold ${card.textColor} mt-2`}>
                {card.value}
              </p>
            </div>
            <span className="text-3xl">{card.icon}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;